import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cardSimulationMoreInfoComponent from './cardSimulationMoreInfo.component';

let cardSimulationMoreInfoModule = angular.module('cardSimulationMoreInfo', [
  uiRouter
])

.component('cardSimulationMoreInfo', cardSimulationMoreInfoComponent)

.name;

export default cardSimulationMoreInfoModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/requestCardSimulationFamily/cardSimulationMoreInfo/cardSimulationMoreInfo.js